"use client";

import { clsx } from "@trydig/ui";
import { Arrow } from "~/components/icons/32/Arrow";
import { useScrollToTop } from "~/lib/hooks/useScrollToTop";
import styles from "./ScrollToTop.module.css";

export const ScrollToTop = () => {
	const scrollToTop = useScrollToTop();

	return (
		<button
			type="button"
			className={clsx(styles["scroll-to-top"], "transparent")}
			onClick={scrollToTop}
		>
			<span className="sr-only">Tilbake til toppen</span>
			<Arrow />
		</button>
	);
};
